import { useRef, useEffect, useState } from "react";

import {
  Container,
  Labels,
  ChartContainer,
  Legenda,
  GreenMarble,
  WhiteMarble,
  LegendLine,
} from "./styles";
import { useGantt } from "../../../hooks/useGantt";
import Chart from "./Chart";

const BurndownChart = () => {
  const ContainerRef = useRef();

  const [dimensions, setDimensions] = useState({
    label1X: 0,
    label1Y: 0,
    label2X: 0,
    label2Y: 0,
    chartX: 0,
    chartY: 0,
    chartWidth: 0,
    chartHeight: 0,
    legendaX: 0,
    legendaY: 0,
  });

  const { criticalPath, criticalDuration, status } = useGantt();
  const criticalData = buildCriticalData(criticalPath, criticalDuration);

  useEffect(() => {
    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  function buildCriticalData(criticalPath, estimatedTime) {
    let yValue = estimatedTime / 24; // Initial y value
    let prevX = 0; // To keep track of the previous task's x without searching
    let tasks = [];

    for (const task of criticalPath) {
      const startDate = new Date(task.start);
      const endDate = new Date(task.end);
      const daysDifference = (endDate - startDate) / (1000 * 60 * 60 * 24); // Convert milliseconds to days

      // Creating new object instead of mutating the original task object
      const newTask = {
        ...task,
        x: prevX + daysDifference,
        y: yValue - task.duration.number / 24,
      };

      // Update tracking variables
      yValue = newTask.y;
      prevX = newTask.x;

      tasks.push(newTask); // Add the new task object to the tasks array
    }

    // Your logic for the last task with the "task" type
    const lastTask = tasks[tasks.length - 1];
    if (lastTask && lastTask.y !== 0) {
      tasks.push({
        x: lastTask.x + lastTask.y,
        y: 0,
      });
    }

    return tasks;
  }

  function handleResize() {
    const containerWidth = ContainerRef.current?.clientWidth;
    const containerHeight = ContainerRef.current?.clientHeight;

    setDimensions((prevDimensions) => ({
      ...prevDimensions,
      label1X: containerWidth * 0.025,
      label1Y: containerHeight * 0.05,
      label2X: containerWidth * 0.88,
      label2Y: containerHeight * 0.875,
      chartX: containerWidth * 0.05,
      chartY: containerHeight * 0.075,
      chartWidth: Math.floor(containerWidth * 0.85),
      chartHeight: Math.floor(containerHeight * 0.9),
      legendaX: Math.floor(containerWidth * 0.84),
      legendaY: Math.floor(containerHeight * 0.13),
    }));
  }

  const {
    label1X,
    label1Y,
    label2X,
    label2Y,
    chartX,
    chartY,
    chartWidth,
    chartHeight,
    legendaX,
    legendaY,
  } = dimensions;

  return (
    <Container ref={ContainerRef} id="zaivu-burndown-chart">
      <ChartContainer top={`${chartY}px`} left={`${chartX}px`}>
        <Chart
          chartHeight={chartHeight}
          chartWidth={chartWidth}
          eTime={criticalDuration / 24}
          cData={criticalData}
        />
      </ChartContainer>
      <Labels top={`${label1Y}px`} left={`${label1X}px`}>
        Dias para conclusão
      </Labels>
      <Labels top={`${label2Y}px`} left={`${label2X}px`}>
        Nº de dias
      </Labels>
      <Legenda top={`${legendaY}px`} left={`${legendaX}px`}>
        <LegendLine>
          <GreenMarble />
          <span>Real</span>
        </LegendLine>
        <LegendLine>
          <WhiteMarble />
          <span>Ideal</span>
        </LegendLine>
      </Legenda>
    </Container>
  );
};

export default BurndownChart;
